<template>
    <div class="container">
        <Loading v-show="loading"/>
        <BallCreate @submitEvent="openMatterInfo({})"/>
        <!--日期页面-->
        <div class="column-date">
            <!-- 日期 -->
            <Calendar ref="calendar"
                      :waitState="waitState"
                      @submitEvent="saveMatterDateArray($event)"/>
            <!-- 分类 -->
            <Category @submitEvent="setShowInfo"/>
        </div>
        <!--清单页面-->
        <div class="column-matter">
            <!-- 清单视图管理 -->
            <MatterManage @submitMatterEvent="switchWaitState"
                          @submitViewEvent="switchViewState"/>
            <!--列表视图-->
            <MatterList ref="matter-list"
                        :matterArray="matterArray"
                        :waitState="waitState"
                        @operateEvent="openOperateCard($event)"
                        @clockEvent="saveClockEvent($event)"
                        @matterEvent="openMatterInfo($event)"
                        @toDayEvent="saveToDay($event)"
                        @setDateEvent="saveSetDate($event)"
                        v-show="!viewState"/>
            <!-- 四象限视图 -->
            <MatterQuadrant ref="matter-quadrant"
                            :matterArray="matterArray"
                            :waitState="waitState"
                            @operateEvent="openOperateCard($event)"
                            @clockEvent="saveClockEvent($event)"
                            @matterEvent="openMatterInfo($event)"
                            v-show="viewState" />
            <OperateCard v-if="cardState"
                         :mouseX="mouseX"
                         :mouseY="mouseY"
                         :matterItem="matterItem"
                         :childItem="childItem"
                         @submitEvent="saveOperate($event)"
                         @closeEvent="switchCardState"/>
            <DeleteCard v-if="deleteState"
                        :repeatState="matterItem.info.iconIsRepeat"
                        :moduleTitle="moduleTitle"
                        @submitEvent="saveDelete($event)"
                        @closeEvent="switchDeleteState"/>
            <MatterInfo ref="matter-info"
                        v-if="infoState"
                        :waitState="waitState"
                        :clockTargetDate="clockTargetDate"
                        :matterItem="matterItem"
                        @submitEvent="setShowInfo"
                        @closeEvent="switchInfoState"/>
        </div>
    </div>
</template>

<script>
import Calendar from "./ColumnDate/Calendar";
import Category from "./ColumnDate/Category";
import MatterManage from "./ColumnMatter/MatterManage";
import MatterList from "./ColumnMatter/MatterList";
import MatterQuadrant from "./ColumnMatter/MatterQuadrant";
import OperateCard from "./ColumnMatter/OperateCard";
import DeleteCard from "./ColumnMatter/DeleteCard";
import MatterInfo from "./MatterInfo";
import Loading from "../Public/Loading";
import BallCreate from "./BallCreate";
import listShowInfo from "@/utils/List/listShowInfo";
import listClockData from "@/utils/List/listClockData";

import { mapState, mapMutations } from "vuex";
export default {
    name: "List",
    components: {
        Loading,
        BallCreate,
        Calendar, // 日历
        Category, // 分类
        MatterManage, //清单
        MatterList, // 列表视图
        MatterQuadrant, // 四象限
        OperateCard, // 四象限
        DeleteCard, // 删除询问
        MatterInfo, // 详情
    },
    data(){
        return {
            infoState: false,
            waitState: false,
            viewState: false,
            cardState: false,
            deleteState: false,
            moduleTitle: "清单",
            matterArray: [],
            matterDateArray: [],
            matterWaitArray: [],

            clockTargetDate: "",
            matterItem: {},
            childItem: {},
            mouseX: 0,
            mouseY: 0,
        }
    },
    computed: {
        ...mapState(["userId"]),
        ...mapState("listModules", {
            tbListInfo: state => state.tbListInfo,
            tbListClock: state => state.tbListClock,
            tbListChild: state => state.tbListChild,
            tbListLine: state => state.tbListLine,
            optId: state => state.optId,
            loading: state => state.loading,
        })
    },
    methods: {
        ...mapMutations("listModules", ["setLoading", "initListData", "setOptId", "setList", "setClock", "setDeleteData"]),
        // 开关
        switchInfoState: function (){
            this.infoState = !this.infoState;
        },
        switchWaitState: function(){
            this.waitState = !this.waitState;
            this.setMatterArray();
        },
        switchViewState: function(){
            this.viewState = !this.viewState;
            this.setMatterArray();
        },
        switchCardState: function (){
            this.cardState = !this.cardState;
        },
        switchDeleteState: function(){
            this.deleteState = !this.deleteState;
        },

        // 请求清单信息
        getListInfo: function(){
            this.setLoading(true);
            this.$api.getSyncList({
                optId: -1,
                listInfoList: [],
                listChildList: [],
                listClockList: [],
                listCategoryList: [],
                listTimeLineList: [],
                listDeleteList: [],
            }).then((res)=>{
                this.setLoading(false);
                if(res.data.code === 200){
                    this.initListData(res.data.data);
                    this.setShowInfo();
                }else{
                    this.$PopupToast("清单数据请求失败")
                }
            })
        },
        // 设置展示信息
        setShowInfo: function(){
            const calendar = this.$refs["calendar"];
            // 设置月展示信息
            calendar.setDayMatters();
            const dayArray = calendar.dayItems.filter((item)=>{
                return item.isClick
            });
            if (dayArray.length > 0){
                const dayItem = dayArray[0];
                this.clockTargetDate = dayItem.date;
                this.matterDateArray = dayItem.matterArray;
            }
            // 设置待办展示信息

            this.matterWaitArray = listShowInfo.setWaitMatters();
            this.setMatterArray();
        },
        /**
         * 保存选择日期的清单
         * @param dayItem
         */
        saveMatterDateArray: function(dayItem) {
            this.matterArray = dayItem.matterArray;
            this.matterDateArray = dayItem.matterArray;
            this.clockTargetDate = dayItem.date;

            this.setMatterArray();
        },
        // 设置选择日期的清单
        setMatterArray: function(){

            if (this.waitState){
                this.matterArray = this.matterWaitArray;
            }else{
                this.matterArray = this.matterDateArray;
            }
            if(this.viewState){
                // 待办
                setTimeout(()=>{
                    this.$refs["matter-quadrant"].setPriorityItems();
                })
            }else{
                // 日期
                setTimeout(()=>{
                    this.$refs["matter-list"].setClockArray();
                })
            }
        },
        // 打开操作卡片
        openOperateCard: function(e){
            this.mouseX = e.mouseX;
            this.mouseY = e.mouseY;
            this.matterItem = e.matterItem;
            this.childItem = e.childItem;

            if(this.childItem.info){
                this.moduleTitle = "子任务"
            }else{
                this.moduleTitle = "清单"
            }

            this.switchCardState();
        },
        // 保存操作卡片
        saveOperate: function(e){

            if(e === 0){
                // 置顶清单
                this.saveTop(1);
            }else if(e === 1){
                // 取消置顶
                this.saveTop(0);
            }else if(e === 2){
                // 成功打卡
                this.saveClock(1);
            }else if(e === 3){
                // 失败打卡
                this.saveClock(2);
            }else{
                // 4 删除清单、子任务
                this.switchDeleteState();
            }
        },
        // 保存打卡事件
        saveClockEvent: function(e){
            this.matterItem = e.matterItem;
            this.childItem = e.childItem;

            this.saveClock();
        },
        // 打开清单详情
        openMatterInfo: function(e){
            this.matterItem = e;
            this.switchInfoState();
        },
        // 保存置顶数据
        saveTop: function(topState){
            const listInfoList = [];
            this.tbListInfo.forEach((item)=>{
                if(item.inventoryId === this.matterItem.info.inventoryId){
                    item.topState = topState;
                    item.dataAction = "update";
                    listInfoList.push(item);
                }
            })
            this.sendRequest(listInfoList, [], []);
        },
        // 移动到今天
        saveToDay: function(e){
            const listInfoList = [];
            this.tbListInfo.forEach((item)=>{
                if(item.inventoryId === e.info.inventoryId){
                    item.startDate = Solar.fromDate(new Date()).toYmd();
                    item.dataAction = "update";
                    listInfoList.push(item);
                }
            })
            this.sendRequest(listInfoList, [], []);
        },
        // 设定日期
        saveSetDate: function(e){
            this.openMatterInfo(e);
            setTimeout(()=>{
                this.$refs["matter-info"].switchState('dateTimeState');
            })
        },
        // 保存打卡数据
        saveClock: function(clockState){
            const listClockList = listClockData.getClockData(this.matterItem, this.childItem, clockState);
            this.sendRequest([], listClockList, [])
        },

        saveDelete: function(deleteType){
            if(this.moduleTitle === '清单'){
                // 删除清单
                this.saveDeleteMatter(deleteType);
            }else{
                // 删除子任务
                const listDeleteList = [{
                    deleteType: "inventory_child",
                    deleteDataId: this.childItem.info.childId
                }];

                this.sendRequest([], [], listDeleteList);
            }
        },
        saveDeleteMatter: function(deleteType){
            const listInfoList = [];
            const listDeleteList = [];
            const inventoryId = this.matterItem.info.inventoryId;
            const clockTargetDate = this.matterItem.timeInfo.clockTargetDate;

            if(deleteType === 0){
                // 删除仅当天
                this.tbListInfo.forEach((item)=>{
                    if(item.inventoryId === inventoryId){
                        let repeatDeleteDates = [];
                        if(item.replaceDeleteDates !== ""){
                            repeatDeleteDates = item.repeatDeleteDates.split(",");
                        }
                        repeatDeleteDates.push(clockTargetDate);
                        item.repeatDeleteDates = repeatDeleteDates.join(",");
                        item.dataAction = "update";
                        listInfoList.push(item);
                    }
                })
                this.tbListLine.forEach((item)=>{
                    if(item.linkInventoryId === inventoryId && item.startDate === clockTargetDate && item.dataType === 1){
                        listDeleteList.push({
                            deleteType: "inventory_branch",
                            branchInventoryId: inventoryId,
                            branchStartDate: clockTargetDate,
                            branchDataType: 1,
                        });
                    }
                })
            }else if(deleteType === 1){
                // 删除当天及以后
                this.tbListInfo.forEach((item)=>{
                    if(item.inventoryId === inventoryId){
                        item.endDate = Solar.fromDate(new Date(clockTargetDate)).next(-1).toYmd();
                        item.dataAction = "update";
                        listInfoList.push(item);
                    }
                })
                this.tbListLine.forEach((item)=>{
                    if(item.linkInventoryId === inventoryId && item.startDate >= clockTargetDate){
                        listDeleteList.push({
                            deleteType: "inventory_branch",
                            branchInventoryId: inventoryId,
                            branchStartDate: clockTargetDate,
                            branchDataType: 1,
                        });
                    }
                })
            }else{
                // 删除所有
                listDeleteList.push({
                    deleteType: "inventory",
                    deleteDataId: inventoryId,
                })
            }
            this.sendRequest(listInfoList, [], listDeleteList)
        },

        sendRequest: function(listInfoList, listClockList, listDeleteList){
            const that = this;
            const params = {
                optId: this.optId,
                listInfoList: listInfoList,
                listClockList: listClockList,
                listCategoryList: [],
                listChildList: [],
                listTimeLineList: [],
                listDeleteList: listDeleteList,
            }
            this.setLoading(true);
            this.$api.getSyncList(params).then((res)=>{
                that.setLoading(false);
                if(res.data.code === 200 && !res.data.data.differenceData){
                    that.setList(listInfoList);
                    that.setClock(listClockList);
                    that.setDeleteData(listDeleteList);

                    that.setOptId(res.data.data.lastOptId);
                    that.setShowInfo();
                }else{
                    that.$PopupToast("保存失败");
                }
            })
        },
    },
    mounted(){
        this.getListInfo();
    }
}
</script>

<style scoped>
div.container{
    width: 100%;
    display: flex;
    background: var(--color-2);
    overflow: hidden;
}
div.column-date{
    width: 3.3rem;
    height: 100%;
    border-right: 0.01rem solid rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}
div.column-matter{
    flex: 1;
    overflow: hidden;
    position: relative;
}

</style>